/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32CriteriaRangeInput
 */
export interface Int32CriteriaRangeInput {
    /**
     * 
     * @type {boolean}
     * @memberof Int32CriteriaRangeInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeInput
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeInput
     */
    to?: number;
}

export function Int32CriteriaRangeInputFromJSON(json: any): Int32CriteriaRangeInput {
    return Int32CriteriaRangeInputFromJSONTyped(json, false);
}

export function Int32CriteriaRangeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32CriteriaRangeInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
    };
}

export function Int32CriteriaRangeInputToJSON(value?: Int32CriteriaRangeInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from,
        'to': value.to,
    };
}


